'use client';
import ImageGallery from "@/components/common/image-gallery";
import { PostContentFallback, useLoadPostBySlug } from "@/components/common/posts/posts.provider";
import { SimilarPosts } from "@/components/common/posts/similar-posts";
import SectionPage from "@/components/common/section-page";


export default function PostPage() {
    const { currentPost, postsBasePath } = useLoadPostBySlug("initiative-cacao-anac");

    return (
        <PostContentFallback>

            <article>
                {currentPost && (
                    <div style={{ backgroundImage: `url(${currentPost.image})` }} className={"h-[400px] w-full bg-cover bg-center relative"}>
                        <div className={"bg-bleu-marine h-[100px] w-full flex items-center justify-start absolute bottom-0"}>
                            <SectionPage sectionType={"2xl"}>
                                <h1 className={"text-white text-4xl font-exo"}>{currentPost.title}</h1>
                            </SectionPage>
                        </div>
                    </div>
                )}

                <SectionPage sectionType={"xl"} className={"my-12"}>
                    <div className="markdown-content text-gray-800">
                        <p className="my-4 text-normal leading-relaxed">
                            Le Directeur Général de l’Office National du Tourisme, Mme Malékah MOURAD – CONDE a pris part ce 28 Novembre à une rencontre qui vise une meilleure synergie d’action avec l’ <a href="https://www.facebook.com/people/Autorit%C3%A9-Nationale-de-lAviation-Civile-ANAC-CI/100076228537340/" target="_blank" rel="noreferrer"><span className={"text-rose"}>Autorité Nationale de l’Aviation Civile – ANAC- CI.</span></a>
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Les 2 structures veulent ainsi coordonner leurs plans de développement stratégiques dans les secteurs du transport aérien et du tourisme pour améliorer leurs études prospectives.
                        </p>
                    </div>


                    <div className={'mt-8'}>
                        <ImageGallery images={
                            Array.from({ length: 4 }).map((_, index) => ({
                                src: `/images${postsBasePath}/${String(currentPost?.slug)}/gallerie/${index + 1}.png`,
                                alt: `image${index + 1}`,
                                width: 700,
                                height: 700,
                            }))
                        } aspectRatio={"video"} gridClassName={"grid grid-cols-1 md:grid-cols-4 gap-4"} />
                    </div>

                    {currentPost && <SimilarPosts currentSlug={currentPost.slug} />}

                </SectionPage>
            </article>
        </PostContentFallback>

    );
}
